<template>
  <div>
    <LayoutNavigation />
    <main>
      <NuxtPage />
    </main>
    <FlashMessage />
    <MandatoryTrainingModal />
  </div>
</template>
